module.exports = __webpack_public_path__ + "static/media/example2_after.265143af.png";